import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Building Details (/building/:buildingID)
 */
export const buildingDetailsTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_BuildingDetails_Welcome_Title"),
    description: t("Tour_BuildingDetails_Welcome_Description"),
    target: () => queryTourTarget("building-details-header"),
    placement: "bottom",
  },
  {
    title: t("Tour_BuildingDetails_Tabs_Title"),
    description: t("Tour_BuildingDetails_Tabs_Description"),
    target: () => queryTourTarget("building-details-tabs"),
    placement: "bottom",
  },
  {
    title: t("Tour_BuildingDetails_AddUnit_Title"),
    description: t("Tour_BuildingDetails_AddUnit_Description"),
    target: () => queryTourTarget("building-add-unit"),
    placement: "left",
  },
];
